import { HUBSPOT_API } from '../constants';

export async function hubspotGet<T>(
  path: string,
  params?: Record<string, string>,
  signal?: AbortSignal
): Promise<T> {
  const query = params ? '?' + new URLSearchParams(params).toString() : '';
  const res = await fetch(`${HUBSPOT_API.PROXY_BASE}/${path}${query}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    signal,
  });

  if (!res.ok) {
    const errBody = await res.text();
    throw new Error(`HubSpot API error ${res.status}: ${errBody}`);
  }

  return res.json();
}

export async function hubspotPost<T>(
  path: string,
  body: unknown,
  signal?: AbortSignal
): Promise<T> {
  const res = await fetch(`${HUBSPOT_API.PROXY_BASE}/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    signal,
  });

  if (!res.ok) {
    const errBody = await res.text();
    throw new Error(`HubSpot API error ${res.status}: ${errBody}`);
  }

  return res.json();
}
